import { browserHistory } from 'react-router';
import _ from 'lodash';

export const toIdMap = ar =>
    ar.reduce((acc, cur) => {
        if (cur._id) {
            acc[cur._id] = cur;
        }
        return acc;
    }, {});

export const toIdArray = ar => ar.reduce((acc, el) => (el._id ? acc.concat(el._id) : acc), []);

export const responseStatusIsOk = status => status >= 200 && status < 300;

export const addToQuery = (key, value) => {
    const { query } = browserHistory.getCurrentLocation();
    const { pathname } = window.location;

    browserHistory.replace({
        pathname,
        query: { ...query, [key]: value }
    });
};

export const removeFromQuery = key => {
    const { query } = browserHistory.getCurrentLocation();
    const { pathname } = window.location;

    browserHistory.replace({
        pathname,
        query: _.omit(query, [key])
    });
};

export const isNullOrUndefined = value => [undefined, null].some(e => e === value);

const badValues = [undefined, null, ''];
export const safeParse = str => {
    if (badValues.some(v => v === str)) {
        return null;
    }
    if (typeof str === 'object') {
        return str;
    }
    try {
        return JSON.parse(str);
    } catch (e) {
        return null;
    }
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/helpers/index.js
 **/